import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { useBeneficiariesStore } from './beneficiaries.store';
import type { BeneficiaryGroup } from './beneficiaries-group.store.types';

export const useBeneficiariesGroupStore = defineStore('beneficiaries-group', () => {
  const beneficiariesStore = useBeneficiariesStore();

  const selectedBeneficiary = ref<{ key: string } | null>(null);
  const selectedBeneficiaryId = computed(() => selectedBeneficiary.value?.key ?? null);

  const groupedBeneficiaries = computed<BeneficiaryGroup[]>(() => {
    if (!beneficiariesStore.beneficiaries || beneficiariesStore.beneficiaries.length === 0) {
      return [];
    }

    const allBeneficiaries = beneficiariesStore.beneficiaries;

    // First 3 items treated as "Recent" (no updatedAt available from API yet)
    const recent = allBeneficiaries.slice(0, 3);
    const recentIds = new Set(recent.map((b) => b.id));
    const rest = allBeneficiaries.filter((b) => !recentIds.has(b.id));

    const toListItem = (beneficiary: (typeof allBeneficiaries)[number]) => ({
      key: beneficiary.id ?? '',
      label: beneficiary.fullName ?? '',
      value: beneficiary.id ?? '',
      avatar: null,
    });

    return [
      {
        label: 'Recent',
        code: 'RECENT',
        items: recent.map(toListItem),
      },
      {
        label: 'Contact List',
        code: 'ALL',
        items: rest.map(toListItem),
      },
    ];
  });

  return {
    groupedBeneficiaries,
    selectedBeneficiary,
    selectedBeneficiaryId,
    isLoading: computed(() => beneficiariesStore.isLoading || false),
    isSuccess: computed(() => beneficiariesStore.isSuccess || false),
  };
});
